import { ReactNode } from "react";

import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Box } from "@mui/material";

interface Props {
  warning: string | undefined;
  children: ReactNode;
}

export const WarningLabel = ({ warning, children }: Props) => (
  <Box display="flex" gap={1.5} alignItems="center">
    {warning && <WarningAmberIcon fontSize="small" color="warning" titleAccess={warning} />}
    {children}
  </Box>
);
